/** iPhone, iPad, and iPadOS (which reports itself as a Mac with a touch screen). */
export function isIOS() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return true;
  return /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
}

/** The element that actually scrolls. iOS scrolls the page; other devices scroll the inner pane. */
export function getScrollElement() {
  if (typeof document === 'undefined') return null;
  if (isIOS()) return document.scrollingElement || document.documentElement;
  return document.querySelector('.main-content');
}

/**
 * On iPhone, bring an invalid field into the middle of the screen and put the cursor in it.
 * Other devices keep their existing scroll behaviour.
 */
export function scrollToField(el) {
  if (!el || !isIOS()) return;
  el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  if (typeof el.focus === 'function') {
    try {
      el.focus({ preventScroll: true });
    } catch (err) {
      el.focus();
    }
  }
}

/** Empty is allowed. Anything else must be a whole number of 1 or more. */
export function guestLimitMessage(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  const n = Number(raw);
  if (!Number.isInteger(n) || n < 1) return 'Enter a whole number of 1 or more';
  return '';
}
